import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { useGeneralStore } from '@/store/modules/general';
export default defineComponent({
    name: 'ToastView',
    setup() {
        const generalStore = useGeneralStore();
        const { toastMessage, displayToast, hideToast, showingToast } = storeToRefs(generalStore);
        return {
            toastMessage,
            displayToast,
            hideToast,
            showingToast,
        };
    },
});
